import {Outlet} from "react-router-dom";

import {Header, IdleLogoutTimer} from "base/layout";
import Box from "@mui/material/Box";
import {FOOTER_HEIGHT, HEADER_HEIGHT} from "base/config/measurements";

const AppLayout = ({hero = null, menu = null, footer = null}) => {
    return (
        <IdleLogoutTimer>
            <Header hero={hero} menu={menu} />
            {process.env.REACT_APP_ENV === "stg" && (
                <Box
                    sx={{
                        textAlign: "center",
                        height: "40px",
                        bgcolor: "rgba(181, 54, 41, 0.9)",
                        borderBottom: "2px solid #8b2a20",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        fontSize: "18px"
                    }}
                >
                    CONTORNA DE PROBAS
                </Box>
            )}
            <Box sx={{minHeight: `calc(100vh - ${HEADER_HEIGHT + FOOTER_HEIGHT}px)`}}>
                <Outlet />
            </Box>
            {footer}
        </IdleLogoutTimer>
    );
};

export default AppLayout;
